import { render, staticRenderFns } from "./AiTranslate.vue?vue&type=template&id=f355c79e&scoped=true"
import script from "./AiTranslate.vue?vue&type=script&lang=js"
export * from "./AiTranslate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f355c79e",
  null
  
)

export default component.exports